import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Layout } from "./components/Layout";
import { Home } from "./pages/Home";
import { Contact } from "./pages/Contact";
import { ServiceDetail } from "./pages/ServiceDetail";
import { LinkedInPage } from "./pages/LinkedInPage";
import { TeamPage } from "./pages/TeamPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/linkedin" element={<LinkedInPage />} />
            <Route path="/equipe" element={<TeamPage />} />
            <Route path="/mentions-legales" element={<ComingSoon title="Mentions Légales" />} />
            <Route path="/politique-confidentialite" element={<ComingSoon title="Politique de Confidentialité" />} />
            <Route path="/cgv" element={<ComingSoon title="Conditions Générales de Vente" />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

// Simple Coming Soon component for legal pages
const ComingSoon = ({ title }) => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center pt-20">
    <div className="text-center px-4">
      <h1 className="text-4xl font-bold text-slate-900 mb-4">{title}</h1>
      <p className="text-xl text-slate-600">Cette page sera bientôt disponible.</p>
    </div>
  </div>
);

export default App;
